// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2Qr8i","footerContainer":"Footer_footerContainer__1xlLL","footerTop":"Footer_footerTop__1bbC6","footerBottom":"Footer_footerBottom__3SIdI"};